import React, { useState } from "react";
import { GraduationCap, CheckCircle2 } from "lucide-react";
import HelpSupportModal from "@/components/HelpSupportModal";

const INCLUDES = [
  "Personalized 1:1 guidance on your Data Cloud learning path",
  "Live walkthroughs of real project scenarios and mock interviews",
  "Resume & LinkedIn profile review with a Salesforce professional",
  "Direct access for questions between sessions",
];

export default function MentorshipPage() {
  const [helpOpen, setHelpOpen] = useState(false);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14 text-center" data-testid="mentorship-page">
      <div className="w-14 h-14 rounded-2xl bg-primary/15 border border-indigo-400/30 flex items-center justify-center mx-auto mb-6">
        <GraduationCap className="w-7 h-7 text-indigo-300" />
      </div>
      <h1 className="font-heading text-3xl sm:text-4xl font-semibold text-white">1:1 Paid Mentorship</h1>
      <p className="text-slate-400 mt-4 max-w-xl mx-auto">
        Want to accelerate your Salesforce Data Cloud career with personal guidance? Book a private mentorship
        session with our team — tailored to your goals, whether that's cracking interviews, leveling up on a
        real project, or planning your next career move.
      </p>

      <div className="glass-panel rounded-2xl p-6 mt-10 text-left max-w-lg mx-auto">
        <p className="text-sm font-semibold text-white mb-4">What's included</p>
        <ul className="space-y-3">
          {INCLUDES.map((item, i) => (
            <li key={i} className="flex items-start gap-2.5 text-sm text-slate-300">
              <CheckCircle2 className="w-4 h-4 text-emerald-400 mt-0.5 shrink-0" />
              {item}
            </li>
          ))}
        </ul>
      </div>

      <p className="text-xs text-slate-500 mt-6">Pricing and availability are shared directly with you by our team based on your goals.</p>

      <button
        onClick={() => setHelpOpen(true)}
        data-testid="mentorship-talk-to-us-button"
        className="mt-6 bg-primary hover:bg-primary/90 text-white text-sm font-semibold px-8 py-3 rounded-lg transition-colors"
      >
        Talk to Us About Mentorship
      </button>

      <HelpSupportModal open={helpOpen} onClose={() => setHelpOpen(false)} />
    </div>
  );
}
